import { constructSortFn } from '@tanstack/react-table';

// Sort functions for TanStack column defs (`sortFn`), shared by DataTable and
// the Watchlist grid. Each returns the ascending order; TanStack reverses it
// for descending. Blank values (null or undefined) that reach them sort
// first, as MUI DataGrid's comparators did. Undefined values reach them only
// when the column's `sortUndefined` is false (DataTable's and the Watchlist's
// default); a column can set `sortUndefined: 'last'` to keep them at the end.

const collator = new Intl.Collator();

// Blank values (null or undefined) come first in ascending order. Null when
// neither value is blank.
function compareBlanksFirst(left, right) {
    if (left == null) return right == null ? 0 : -1;
    if (right == null) return 1;
    return null;
}

/** Text in the browser's collation order, blank values first. */
export const sortByText = constructSortFn({
    sort: (left, right) => compareBlanksFirst(left, right) ?? collator.compare(String(left), String(right)),
});

/** Numbers, blank values first. */
export const sortByNumber = constructSortFn({
    sort: (left, right) => compareBlanksFirst(left, right) ?? left - right,
});

/**
 * Numbers by size whatever their sign (trade ideas, GMV): -5 sorts with 5,
 * blank values first. Numeric strings count as their number.
 */
export const sortByAbsoluteNumber = constructSortFn({
    sort: (left, right) => compareBlanksFirst(left, right) ?? Math.abs(left) - Math.abs(right),
});
